import React, { Component } from 'react';
import TextEllipsis from 'react-text-ellipsis';
import { connect } from 'react-redux';
import './TextResult.scss';
import { setCurrentItem } from '../../redux/actions/result.action';
import { push } from 'connected-react-router';

class TextResult extends Component<{ text: any, action?: any, navigateTo: any }, { currIndex: number, currIndex2: number }> {
  constructor(props: any) {
    super(props);
    this.state = {
      currIndex: -1,
      currIndex2: -1
    }
  }

  /**
   * Main render method
   */
  render() {
    return (
      <div className="textresult" onClick={() => {
        //textpreview
        this.props.navigateTo('/textpreview', this.props.text);
      }}>
        <div className="title">
          {this.props.text.name}
        </div>
        <div className="text">

          <TextEllipsis
            lines={5}
            tag={'p'}
            ellipsisChars={'...'}
            tagClass={'className'}
            debounceTimeoutOnResize={200}
            useJsOnly={true}
          >
            {this.props.text.snippet}
          </TextEllipsis>
        </div>
      </div>
    );
  }
}


const mapStateToProps = (state: any) => {
  return {
  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    navigateTo(path: string, item: any) {

      dispatch(setCurrentItem(item));
      dispatch(push(path))
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TextResult);